export const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        maxWidth: '328px',
        width: '100%',
        padding: '22px',
        paddingTop: '30px',
        borderRadius: '20px',
        boxShadow: '0 8px 16px 0 rgba(79, 115, 151, 0.17)',
        border: 'solid 1px #e1e8ee'
    }
}
